import { LmIconOutlineMiscSchool } from '@mes-ui/lemma/icons';

const IconSchoolOutline = (props: React.SVGProps<SVGSVGElement>) => <LmIconOutlineMiscSchool {...props} />;

export default IconSchoolOutline;
